export default "__VITE_ASSET__0e6057a0__"